module.exports = __webpack_public_path__ + "d2cb020a.png";